import type { FeatureToggleType } from "@/shared/common/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface FeatureToggleState {
  toggles: FeatureToggleType;
  isLoaded: boolean;
}

const initialState: FeatureToggleState = {
  toggles: {
    isQRLoginAvailable: false,
    isCardTransferAvailable: false,
    isCardTransferUpdateAvailable: false,
    isCardTransferCopyAvailable: false,
    isCardStatementAvailable: false,
    isBudgetTransferAvailable: false,
    isBudgetTransferUpdateAvailable: false,
    isBudgetTransferCopyAvailable: false,
    isDepositScheduleAvailable: false,
    isDepositStatementAvailable: false,
    isLoanScheduleAvailable: false,
    isLoanStatementAvailable: false,
    isAccountTransferAvailable: false,
    isAccountTransferUpdateAvailable: false,
    isAccountTransferCopyAvailable: false,
    isAccountStatementAvailable: false,
    isAccountRequisiteAvailable: false,
    isOwnAccountTransferAvailable: false,
    isOwnAccountTransferUpdateAvailable: false,
    isOwnAccountTransferCopyAvailable: false,
    isCurrencyExchangeAvailable: false,
    isCurrencyExchangeUpdateAvailable: false,
    isCurrencyExchangeCopyAvailable: false,
    isGroupTransferAvailable: false,
    isGroupTransferUpdateAvailable: false,
    isGroupTransferCopyAvailable: false,
    isAccountOpeningApplicationAvailable: false,
    isAccountClosureApplicationAvailable: false,
    isPhoneBankingApplicationAvailable: false,
    isPayrollCardOpeningApplicationAvailable: false,
    isLoanTrancheDisbursementApplicationAvailable: false,
    isPaymentCardServiceInstructionApplicationAvailable: false,
    isPeriodicalPaymentsApplicationAvailable: false,
    isUserOpeningApplicationAvailable: false,
    isDepositTerminationApplicationAvailable: false,
    isLoanRepaymentAvailable: false,
    isLoanRepaymentUpdateAvailable: false,
    isLoanRepaymentCopyAvailable: false,
    isTemplatesAvailable: false,
    isBeneficiaryAvailable: false,
    isBudgetTransferTemplateAvailable: false,
  },
  isLoaded: false,
};

const featureToggleSlice = createSlice({
  name: "featureToggle",
  initialState,
  reducers: {
    setFeatureToggle(state, action: PayloadAction<FeatureToggleType>) {
      state.toggles = action.payload;
      state.isLoaded = true;
    },
  },
});

export const { setFeatureToggle } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;
